import styled, { css } from 'styled-components';
import ChevronLeft from 'mdi-react/ChevronLeftIcon';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import { Clickable } from 'src/components/clickable';
import { layout } from 'src/components/base';

const padding = layout.measurements.spacing050;

type ListItemProps = {
  disabled?: boolean;
};

export const ListItem = styled(Clickable)<ListItemProps>`
  color: ${props => props.theme.text.primary};
  cursor: pointer;
  min-height: 48px;
  padding: ${layout.measurements.spacing025} ${padding};
  text-align: left;
  display: flex;
  align-items: center;

  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */
  box-sizing: border-box;
  width: 100%;

  &:hover,
  &.focus-visible {
    background-color: ${props => props.theme.bg.secondary};
    outline: 0;
  }

  ${props =>
    props.disabled &&
    css`
      cursor: default;
      opacity: 0.5;
    `}
`;

export const Image = styled.div`
  margin-right: ${padding};
`;

export const Name = styled.span`
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CallToAction = styled.span`
  color: ${props => props.theme.text.callToAction};
  flex: 0 1 50%;
  margin-left: ${padding};
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RightArrow = styled(ChevronRight).attrs({ size: 20 })`
  flex: 0 0 auto;
  margin-left: ${padding};
  path {
    fill: currentColor;
  }
`;

export const LeftArrow = styled(ChevronLeft).attrs({ size: 20 })`
  flex: 0 0 auto;
  margin-right: ${padding};
  path {
    fill: currentColor;
  }
`;
